import React, { FC } from 'react'

import { useDispatch } from 'react-redux'

import { goBackAction } from 'actions/system/routeAction'
import { PlainLink } from 'components/presentational/link'
import { BackSvg } from 'components/presentational/svg/BackSvg'

import { NavigationInner } from './UniNoticeNavigation.styled'

export const UniNoticeNavigation: FC = () => {
  const dispatch = useDispatch()

  return (
    <NavigationInner>
      <PlainLink
        data-name="link-go-back-action"
        onClick={(event) => {
          event.preventDefault()
          dispatch(goBackAction())
        }}
      >
        <BackSvg />
      </PlainLink>
    </NavigationInner>
  )
}
